import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import { forgotPasswordPath } from 'components/Routes'
import { signUpPath } from 'components/Routes'
import { useAuth } from 'components/AuthProvider'

import Button from 'components/Button'
import DefaultLayout from 'components/layout/DefaultLayout'
import { Grid2, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { Field, FieldProps, Formik } from 'formik'
import * as Yup from 'yup'
import { TextField } from 'formik-mui'

const useStyles = makeStyles()((theme: Theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2)
  },
  link: {
    color: theme.palette.primary.main
  }
}))

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Email is invalid').required('Email is required')
})

export default function ResendConfirmationEmail(): JSX.Element {
  const { classes } = useStyles()

  const { resend, loading } = useAuth()

  const recaptchaEnabled = JSON.parse(
    process.env.REACT_APP_RECAPTCHA_ENABLED || 'true'
  )
  const { executeRecaptcha } = useGoogleReCaptcha()

  async function handleSubmit(values: { email: string }) {
    if (!executeRecaptcha && recaptchaEnabled) return

    const token =
      recaptchaEnabled &&
      executeRecaptcha &&
      (await executeRecaptcha('users/resend'))

    resend(values.email, token)
  }

  return (
    <DefaultLayout containerMaxWidth='xs' heading='Resend confirmation email'>
      <Formik
        initialValues={{ email: '' }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => (
          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12 }}>
                <Field name='email'>
                  {({ field, form, meta }: FieldProps) => (
                    <TextField
                      field={field}
                      form={form}
                      meta={meta}
                      fullWidth
                      required
                      label='Email address'
                    />
                  )}
                </Field>
              </Grid2>

              <Grid2 container sx={{ justifyContent: 'center' }}>
                <Button
                  color='primary'
                  fullWidth
                  disabled={loading}
                  type='submit'
                >
                  Resend instructions
                </Button>
              </Grid2>

              <Grid2 container>
                <Link
                  color='textPrimary'
                  component={RouterLink}
                  to={forgotPasswordPath()}
                  underline='always'
                  className={classes.link}
                >
                  Forgot password?
                </Link>
              </Grid2>
              <Grid2 container>
                <Link
                  color='textPrimary'
                  component={RouterLink}
                  to={signUpPath()}
                  underline='always'
                  className={classes.link}
                >
                  Don't have an account? Sign Up
                </Link>
              </Grid2>
            </Grid2>
          </form>
        )}
      </Formik>
    </DefaultLayout>
  )
}
